<template>
  <v-container :style="cssTheme">
    <v-list :style="getHoverColor">
      <v-list-group
        v-for="(attr, index) in items"
        :key="index"
        append-icon
        :ripple="false"
        :class="index % 2 === 0 ? 'tile ' : 'normal'"
      >
        <template v-slot:activator>
          <v-container class="py-0 px-0">
            <v-row align="center">
              <v-col
                :cols="listViewCols[dimension][breakpoint].attribute"
                class="px-0 py-0 pl-xl-5"
              >
                <v-list-item class="pr-0">
                  <v-list-item-content>
                    <v-list-item-title
                      style="color:#9E9E9E; white-space: normal;"
                      >{{ attr.text }}</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col
                :cols="listViewCols[dimension][breakpoint].value"
                class="px-0 py-0"
              >
                <v-list-item class="text_select">
                  <v-list-item-content>
                    <v-list-item-title
                      :link="true"
                      v-if="links[attr.attribute] && attr.value !== '-'"
                    >
                      <div class="link_style">
                        <a
                          style="text-decoration:none;"
                          :href="getHref(attr.value, links[attr.attribute])"
                          @click="
                            redirect(attr.value, links[attr.attribute], $event)
                          "
                        >
                          <span
                            v-if="attributes[index]['type'] === 'address'"
                            >{{ cropStrMiddle(attr.value) }}</span
                          >
                          <span v-else>{{ attr.value }}</span>
                        </a>
                      </div>
                    </v-list-item-title>
                    <v-list-item-title
                      v-else-if="
                        attributes[index]['type'] === 'time_ago' &&
                          attr.value !== '-'
                      "
                    >
                      <timeago
                        :datetime="attr.value"
                        :auto-update="60"
                        style="white-space: normal;"
                      ></timeago>
                    </v-list-item-title>
                    <v-list-item-title
                      :link="true"
                      v-else
                      :style="
                        attr.attribute === 'description' ||
                        attr.attribute === 'attachment'
                          ? 'color:#444444; white-space: normal;'
                          : 'overflow-x: auto; text-overflow: initial'
                      "
                    >
                      <span>{{ attr.value }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </v-list-group>
    </v-list>
    <v-card flat class="d-flex justify-center py-5" v-if="isLoadingMore">
      <v-progress-circular
        :size="30"
        :width="3"
        color="primary"
        indeterminate
      />
    </v-card>
    <v-card flat v-else-if="showError" class="d-flex justify-center pt-0">
      <span>{{ this.notification }}</span>
    </v-card>
    <v-card flat v-else-if="hasCachedData" class="pb-2">
      <v-btn
        color="primary"
        block
        text
        class="original-text-button"
        @click="loadMoreData()"
      >
        <span>More Information</span>
        <v-icon>mdi-chevron-double-down</v-icon>
      </v-btn>
    </v-card>
    <v-card
      flat
      v-else-if="this.$router.currentRoute.name === 'general'"
      height="12px"
    ></v-card>
  </v-container>
</template>
<script>
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import Big from "big.js";
export default {
  props: {
    data: {
      type: Object
    },
    attributes: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: () => 0
    },
    offset: {
      type: Number,
      default: () => 0
    },
    links: {
      type: Object,
      default: () => ({})
    },
    dimension: {
      type: String,
      default: () => "single"
    }
  },
  watch: {
    queryAnswer(val) {
      if (val) {
        this.getStateData();
      }
    },
    curBlockHeight(val) {
      if (
        val !== 0 &&
        this.itemsJson.result &&
        this.itemsJson.result.confirmations
      ) {
        this.itemsJson.result.confirmations = this.thousandsformat(
          this.curBlockHeight - this.itemsJson.height
        );
        this.fillTable();
      }
    }
  },
  data() {
    return {
      addItemNum: 0,
      cache: [],
      items: [],
      itemsJson: {},
      isLoadingMore: false,
      presentNum: 0,
      hasCachedData: false,
      showNotification: false,
      notification: "no data",
      showError: false,
      attrIndice: {},
      valueStyle: [],
      breakpoint: this.$vuetify.breakpoint.name,
      listViewCols: {
        single: {
          xs: { attribute: 5, value: 7 },
          sm: { attribute: 5, value: 7 },
          md: { attribute: 5, value: 7 },
          lg: { attribute: 2, value: 10 },
          xl: { attribute: 2, value: 10 }
        },
        double: {
          xs: { attribute: 5, value: 7 },
          sm: { attribute: 5, value: 7 },
          md: { attribute: 5, value: 7 },
          lg: { attribute: 3, value: 9 },
          xl: { attribute: 4, value: 8 }
        }
      },
      hoverColor: {
        red: "rgba(255, 84, 106, 0.15)",
        yellow: "rgba(255, 161, 0, 0.15)",
        purple: "rgba(130, 65, 249, 0.15)",
        blue: "rgba(6, 142, 241, 0.15)",
        cyan: "rgba(0, 184, 175, 0.15)"
      },
      breakpointPadding: {
        xs: "px-0 py-0",
        sm: "px-0 py-0",
        md: "px-0 py-0",
        lg: "px-0 py-0",
        xl: "pl-5 pr-0 py-0"
      }
    };
  },
  computed: {
    ...mapState([
      "tokenId",
      "reloadPage",
      "tokenInfo",
      "curBlockHeight",
      "theme",
      "queryAnswer"
    ]),
    getHoverColor() {
      return this.theme
        ? {
            "--hover-color": this.hoverColor[this.theme]
          }
        : {
            "--hover-color": this.hoverColor.cyan
          };
    },
    cssTheme() {
      return {
        "--active-theme": this.$vuetify.theme.themes.light.primary
      };
    }
  },
  created() {
    this.isLoadingMore = true;
    if (this.data && Object.keys(this.data).length > 0) {
      this.itemsJson = Object.assign({}, this.itemsJson, this.data);
      this.fillTable();
    } else if (this.queryAnswer) {
      this.getStateData();
    }
    this.hasCachedData = !(this.limit === this.attributes.length);

    setTimeout(() => {
      if (this.items && this.items.length === 0) {
        this.isLoadingMore = false;
        this.showNotification = true;
        this.notification = "Cannot get data from remote.";
        this.showError = true;
      }
    }, 30 * 1000);
  },
  mounted() {
    let resizeId;
    window.addEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(() => {
        this.breakpoint = this.$vuetify.breakpoint.name;
      }, 500);
    });
  },
  beforeDestroy() {
    let resizeId;
    window.removeEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(() => {
        this.breakpoint = this.$vuetify.breakpoint.name;
      }, 500);
    });
  },
  methods: {
    ...mapMutations(["updateReloadPage", "updateQueryAnswer"]),
    headCapitalize(str) {
      if (!str || str.length === 0 || str === "-") {
        return "-";
      }
      const reg = /^[A-Za-z]/;
      if (!reg.test(str.charAt(0))) {
        return str;
      }
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getStateData() {
      this.itemsJson = Object.assign({}, this.itemsJson, this.queryAnswer);
      if (Object.keys(this.itemsJson).length === 0) {
        this.itemsJson = this.attributes.reduce((accum, attr) => {
          accum[attr.value] = null;
          return accum;
        }, {});
      }
      this.updateQueryAnswer(null);
      this.fillTable();
    },
    getHref(id, urlPath) {
      if (urlPath.startsWith("http") || urlPath.startsWith("https")) {
        return urlPath + id;
      }
      const page = urlPath.substring(0, urlPath.indexOf("/:"));
      const route = page + "/" + id;
      return route;
    },
    valueChanged(index) {
      Vue.set(this.valueStyle, index, "background: orange;");
      setTimeout(() => {
        Vue.set(this.valueStyle, index, "");
      }, 500);
    },
    // find difference of two obj which depth is 1
    updatedAttrInObj(obj) {
      let diff = [];
      for (let prop in obj) {
        if (
          obj.hasOwnProperty(prop) &&
          this.itemsJson &&
          this.itemsJson[prop] &&
          this.itemsJson[prop] !== obj[prop]
        ) {
          diff.push(prop);
        }
      }
      return diff;
    },
    dataTransform() {
      if (!this.itemsJson || Object.keys(this.itemsJson).length === 0) {
        return;
      }
      const result = this.attributes.map(attr => {
        let listElement = {
          attribute: attr.value,
          text: attr.text,
          value: this.itemsJson[attr.value]
        };
        if (
          !this.itemsJson[attr.value] &&
          this.itemsJson["content"] &&
          this.itemsJson["content"]["data"]
        ) {
          listElement = {
            attribute: attr.value,
            text: attr.text,
            value: this.itemsJson["content"]["data"][attr.value]
          };
        }
        listElement.value =
          listElement.value === null || listElement.value === undefined
            ? "-"
            : listElement.value;
        if (attr.type) {
          listElement.value = this.reformByType(attr.type, listElement.value);
        }
        return listElement;
      });
      return result;
    },
    cropStrMiddle(id) {
      if (this.breakpoint === "xl" || this.breakpoint === "lg") {
        return id;
      }
      const placeholder = "......";
      const strLen = id.length;
      const bitsReserve = strLen <= 12 ? strLen / 3 : 6;
      return (
        id.substring(0, bitsReserve) +
        placeholder +
        id.substring(strLen - bitsReserve, strLen)
      );
    },
    reformByType(type, value) {
      if (!type || !value) {
        return value;
      }
      switch (type) {
        case "timestamp":
          return this.formatLocalTime(value);
        case "transform_unity":
          return this.thousandsformat(
            this.bigDivision(value, this.tokenInfo.unity)
          );
        case "head_capitalize":
          return this.headCapitalize(value);
        case "time_ago":
          return this.cutTimeStamp(value);
        case "thousands":
          return this.thousandsformat(value);
        case "confirmations":
          return this.curBlockHeight
            ? this.thousandsformat(this.curBlockHeight - this.itemsJson.height)
            : value;
        default: {
          return value;
        }
      }
    },
    timeSince(timestamp) {
      const date = new Date(this.cutTimeStamp(timestamp));
      let seconds = Math.floor((new Date() - date) / 1000);
      let interval = Math.floor(seconds / 31536000);
      if (interval > 1) {
        return interval + " years ago";
      }
      interval = Math.floor(seconds / 2592000);
      if (interval > 1) {
        return interval + " months ago";
      }
      interval = Math.floor(seconds / 86400);
      if (interval > 1) {
        return interval + " days ago";
      }
      interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return interval + " hours ago";
      }
      interval = Math.floor(seconds / 60);
      if (interval > 1) {
        return interval + " minutes ago";
      }
      return Math.floor(seconds) + " seconds ago";
    },
    bigDivision(arg1, arg2) {
      arg1 = arg1 === "-" ? 0 : arg1;
      // Big.NE = -21;
      Big.NE = -(String(this.tokenInfo.unity).length + 1);
      const dividend = new Big(arg1);
      const dividor = new Big(arg2);
      let result = dividend.div(dividor);
      return result.toString();
    },
    cutTimeStamp(timestamp) {
      if (!timestamp) {
        return "-";
      }
      const timestampStr = timestamp.toString();
      const timestampLen = timestampStr.length;
      if (timestampLen > 13) {
        const lengthDiff = timestampLen - 13;
        const divider = Math.pow(10, lengthDiff);
        timestamp = Math.round(timestamp / divider);
      }
      return timestamp;
    },
    isNumeric(n) {
      return typeof n !== "boolean" && !isNaN(n);
    },
    thousandsformat(t) {
      if (t === "-") {
        return 0;
      }
      if (!this.isNumeric(t)) {
        throw new Error("Error: Cannot convert nonnumeric data to thousands.");
      }
      const numStr = String(t);
      const numStrLen = numStr.length;
      const pointIndex =
        numStr.indexOf(".") > 0 ? numStr.indexOf(".") : numStrLen;
      let result = numStr
        .substring(0, pointIndex)
        .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
      if (pointIndex > 0 && pointIndex < numStrLen) {
        result = result + numStr.substring(pointIndex, numStrLen);
      }
      return result;
    },
    formatLocalTime(timestamp) {
      if (!timestamp || timestamp === "-") {
        return "-";
      }
      const timestampStr = timestamp.toString();
      const timestampLen = timestampStr.length;
      if (timestampLen > 13) {
        const lengthDiff = timestampLen - 13;
        const divider = Math.pow(10, lengthDiff);
        timestamp = timestamp / divider;
      }
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const MM =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      const dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      const hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      const mm =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      const ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return `${year}/${MM}/${dd} ${hh}:${mm}:${ss}`;
    },
    fillTable() {
      if (this.breakpoint === "xl" || this.breakpoint === "lg") {
        this.presentNum = Object.keys(this.itemsJson).length;
      } else {
        this.presentNum = this.presentNum === 0 ? this.limit : this.presentNum;
      }
      this.addItemNum = Object.keys(this.itemsJson).length - this.presentNum;
      this.cache = this.dataTransform();
      if (!this.cache || this.cache.length <= 0) {
        return;
      }
      if (this.presentNum === 0) {
        this.presentNum = Math.round(this.cache.length / 2);
      }
      if (this.addItemNum === 0) {
        this.addItemNum = Math.round(this.cache.length / 2);
      }
      this.cache.some((item, index) => {
        Vue.set(this.items, index, item);
        this.attrIndice[item.attribute] = index;
        return index === this.presentNum - 1;
      });
      this.cache = this.cache.slice(this.presentNum);
      if (this.cache.length === 0) {
        this.hasCachedData = false;
      }
      this.isLoadingMore = !(this.items.length > 0);
      this.showError = false;
    },
    loadMoreData() {
      if (this.cache.length === 0) {
        return;
      }
      this.isLoadingMore = true;
      if (this.cache.length < this.addItemNum) {
        this.addItemNum = this.cache.length;
      }
      const that = this;
      setTimeout(() => {
        let pos = that.items.length;
        that.cache.some((item, index) => {
          Vue.set(that.items, pos + index, item);
          this.attrIndice[item.attribute] = pos + index;
          this.presentNum++;
          return index === that.addItemNum - 1;
        });
        that.cache = that.cache.slice(that.addItemNum);
        this.isLoadingMore = false;
        if (this.cache.length === 0) {
          this.hasCachedData = false;
        }
      }, 500);
    },
    redirect(id, urlPath, e) {
      e.preventDefault();
      // repalce :address/ or :transactionId/ with id
      if (urlPath.startsWith("http") || urlPath.startsWith("https")) {
        window.open(urlPath + id, "_blank");
        return;
      }
      const page = urlPath.substring(0, urlPath.indexOf("/:"));
      const route = page + "/" + id;
      const curUrl = this.$router.currentRoute.fullPath;
      if (curUrl.length !== route.length) {
        this.$router.push({
          path: route
        });
      } else if (route != curUrl) {
        this.$router.replace({
          path: route
        });
      } else {
        //reload page
        this.updateReloadPage(true);
        const that = this;
        setTimeout(() => {
          that.updateReloadPage(false);
        }, 500);
      }
    }
  }
};
</script>
<style scoped>
.link_style {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: var(--active-theme);
}
.tile {
  background: #f7f7f7;
}
.tile:hover {
  background: var(--hover-color);
}
.normal {
  background: #ffffff;
}
.normal:hover {
  background: var(--hover-color);
}
.text_select {
  -webkit-user-select: text;
  -moz-user-select: text;
  -o-user-select: text;
  user-select: text;
}
</style>
<style>
.v-list-item {
  padding: 0 12px !important;
  font-size: 14px;
  font-weight: 400;
}
.v-list-item__title {
  font-size: 14px !important;
  font-weight: 400;
}
</style>
